import Axios from 'axios';
import { Action, ActionT } from '../../framework/framework/components/Types';
import { ApplicationContext } from '../../framework/framework/shared/ApplicationContext';
import { IRegisterData } from './IRegisterData';
import { IFormData } from '../../pages/contact/ContactPage';
import { parseErrors } from '../../framework/framework/tools/parseErrors';
import Emitter from '../eventEmmiter/EventEmmiter';
import { EventTypes } from '../eventEmmiter/EventTypes';

export class AccountService {
    private static instance: AccountService;

    static Instance() {
        return AccountService.instance;
    }

    static appCtx: ApplicationContext;

    static init(appCtx: ApplicationContext) {
        AccountService.appCtx = appCtx;
        AccountService.instance = new AccountService();
    }

    axios = Axios;

    get appCtx() { return AccountService.appCtx; }

    onError(error: any, action?: Action) {
        if (error.response.status === 404) {
            if (error.response.data && error.response.data.redirect) {
                const url = this.appCtx.buildUrl(error.response.data.redirect);
                window.location.href = url;
                return;
            }
        }
        if (action) {
            action();
        }
    }

    register(data: IRegisterData, onSuccess: Action, onError: ActionT<any>) {
        const url = this.appCtx.buildUrl('Account/Register');
        this.axios.post(url, data)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                const data = error.response.data;
                const errors = parseErrors(data);
                onError(errors);
            });
    }

    contact(data: IFormData, onSuccess: Action, onError: ActionT<any>) {
        const url = this.appCtx.buildUrl('Account/Contact');
        this.axios.post(url, data)
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                const data = error.response.data;
                const errors = parseErrors(data);
                onError(errors);
            });
    }

    activate(id: string, onSuccess: Action, onError: ActionT<any>) {
        const url = this.appCtx.buildUrl('Account/activate');
        this.axios.post(url, { id: id })
            .then(() => {
                onSuccess();
            })
            .catch(error => {
                const data = error.response.data;
                const errors = parseErrors(data);
                onError(errors);
            });
    }

    login(email: string, password: string, onSuccess: Action, onError: Action) {
        const url = this.appCtx.buildUrl('Account/Login');
        this.axios.post(url, { email: email, password: password })
            .then(() => {
                Emitter.emit(EventTypes.UserData, null);
                onSuccess();
            })
            .catch(error => {
                this.onError(error, onError);
            });
    }

    // getuserData() {
    //     const url = this.appCtx.buildUrl('Account/UserData');
    //     this.axios.get(url)
    //         .then(response => {
    //             debugger;
    //             Emitter.emit(EventTypes.UserData, response.data);

    //         })
    //         .catch(error => {
    //             this.onError(error);
    //         });
    // }
}
